module.exports = __webpack_public_path__ + "img/Reports.5bc7bb01.svg";